import React, { useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    Tabs,
    Tab,
    Box,
    Button,
    TextField,
    Typography,
} from "@mui/material";
import styles from './index.module.css';
import CustomTextField from "../CustomTextField";
import { uploadFile } from '../../services/customerFiles'
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";

const IMG_EXT_RX = /\.(png|jpe?g|gif|webp|bmp)$/i;
const getExt = (name = "") => {
  const m = String(name).match(/\.([a-z0-9]+)(?:\?|#|$)/i);
  return m ? m[1].toUpperCase() : "FILE";
};

const UploadModal = ({ open, onClose, handleDone, onSelectImage, setUploadModalOpen, customerId, }) => {
    const [tab, setTab] = useState(0);
    const [url, setUrl] = useState("");
    const [selectedFile, setSelectedFile] = useState(null);
    const [uploading, setUploading] = useState(false);
    const [imgBroken, setImgBroken] = useState(false);
    const [uploadError, setUploadError] = useState("");
    const handleTabChange = (_, newValue) => {
        setTab(newValue);
    };
    const handleUpload = async () => {
        setUploadError("");
        if (tab === 0 && selectedFile && !customerId) {
            console.warn("[UploadModal] Cannot upload customer file: missing customerId");
            setUploadError("Cannot upload this file because the customer could not be identified. Please close and reopen the item, then try again.");
            return;
        }

        if (tab === 0 && selectedFile && customerId) {
            setUploading(true);
            try {

                const formdata = new FormData();
                formdata.append("file", selectedFile);
                formdata.append("folder", "unfiled");

                await handleDone(customerId, formdata);
                onClose();

            } catch (error) {
                console.error("Upload failed:", error);
            } finally {
                setUploading(false);
            }
        } else if (tab === 1 && url) {
            // onSelectImage(url);
            onClose();
        } else {
            onClose();
        }
    };
    const handleSelectFromWeb = () => {
        if (url) {
            // onSelectImage(url);
            onClose();
        }
    };
    const handleFieldChange = (e) => {
        const { name, value } = e.target;
        // onChange(name, value);
    };
    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle><Box display="flex" justifyContent="space-between" alignItems="center" p={2}>
                <Typography variant="h6">Select Product Image</Typography>
                <Button variant="outlined" onClick={handleUpload} disabled={uploading}>
                    {uploading ? "Uploading..." : "Done"}
                </Button>
            </Box></DialogTitle>
            <DialogContent>
                <Tabs value={tab} onChange={handleTabChange} variant="fullWidth"
                    TabIndicatorProps={{
                        style: {
                            backgroundColor: '#af0000', // <-- custom color here
                        },
                    }}>
                    <Tab className={`${styles.tabRoot} ${tab === 0 ? styles.tabSelected : ""}`}
                        label="Upload from Device"
                        sx={{
                            borderBottom: tab === 0 ? '3px solid #af0000' : '3px solid transparent',
                            color: tab === 0 ? '#af0000' : '#000',
                        }}
                    />
                    <Tab label="From Web" className={`${styles.tabRoot} ${tab === 1 ? styles.tabSelected : ""}`}
                        sx={{
                            borderBottom: tab === 1 ? '3px solid #af0000' : '3px solid transparent',
                        }} />
                </Tabs>

                {tab === 0 && (
                    <Box className={styles.uploadBox}>
                        <Typography>Drag & Drop or Click to Upload</Typography>
                        {selectedFile && (
                            <Typography variant="body2" color="textSecondary" mt={1}>
                                Selected File: {selectedFile.name}
                            </Typography>
                        )}
                        <input
                            type="file"
                            accept="image/*,application/pdf,.svg,.ai,.eps"
                            className={styles.fileInput}
                            onChange={(e) => {
                                const file = e.target.files[0];
                                if (file) {
                                    setImgBroken(false);
                                    setUploadError("");
                                    setSelectedFile(file); // store for upload
                                }
                            }}
                        />
                        {uploadError && (
                            <Typography variant="body2" color="error" mt={1}>
                                {uploadError}
                            </Typography>
                        )}
                    </Box>
                )}

                {tab === 1 && (
                    <Box mt={2} display="flex" gap={2} >
                        <Box className={styles.field}>
                            <CustomTextField
                                handleChange={handleFieldChange}
                                value={url}
                                // label="Supplier"
                                isRequired={true}
                                name="url"
                                placeholder="http://ww..."
                            />
                        </Box>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleSelectFromWeb}
                        >
                            Select
                        </Button>
                    </Box>
                )}
            </DialogContent>
        </Dialog>
    );
};

export default UploadModal;
